<template>
    <div>
        <h3>Add New Survey Page</h3>
        <div class="large-form" style="margin-bottom: 0">
            <div id="survey-page-choices">
                <div class="choices-section" v-for="choicesSection in pageTypeChoices" :id='"choices-section-"+choicesSection.id'>
                    <h5 v-html="choicesSection.label"></h5>
                    <div class="choices-section-options">
                        <div class="choices-option" v-for="choicesOption in choicesSection.choices" :class="'type-'+choicesOption.value" @click="pageTypeChoice(choicesOption)">
                            {{ choicesOption.text }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'NewPageForm',
    props: {
        page: {
            type: Object,
            default: () => ({
                name: undefined,
                type: 'question',
                page_logic_type: 'next_page',
                page_logic_value: undefined,
                display_title: false,
                button_text: undefined,
                logic_rules: []
            })
        },
        storeName: {
            type: String,
            default: 'surveyPages'
        },
    },
    data() {
        return {
            model: {
                name: undefined,
                title: undefined,
                display_title: false,
                page_logic_type: 'next_page',
                page_logic_value: undefined,
                type: 'question',
                logic_rules: []
            },
            
            pageTypeChoices: [
                {
                    id: 'rating',
                    label: '<b>Rating & Ranking</b> Questions',
                    choices: [
                        { value: 'opinion-scale', text: 'Opinion scale' },
                        { value: 'rating', text: 'Rating' },
                        { value: 'ranking', text: 'Ranking' },
                    ]
                },
                {
                    id: 'text',
                    label: '<b>Text & Contact Info</b> Questions',
                    choices: [
                        { value: 'email', text: 'Email' },
                        { value: 'phone-number', text: 'Phone number' },
                        { value: 'website', text: 'Website' },
                        { value: 'short-text', text: 'Short text' },
                        { value: 'long-text', text: 'Long text' },
                        { value: 'number', text: 'Number' },
                    ]
                },
                {
                    id: 'choice',
                    label: '<b>Single & Multiple Choice</b> Questions',
                    choices: [
                        { value: 'single-choice', text: 'Single choice' },
                        { value: 'multiple-choice', text: 'Multiple choice' },
                        { value: 'boolean', text: 'Yes / No Question' },
                        { value: 'date', text: 'Date' },
                    ]
                },
                {
                    id: 'context',
                    label: '<b>Static & Context</b> Pages',
                    choices: [
                        { value: 'welcome', text: 'Welcome Page' },
                        { value: 'context', text: 'Statement Page' },
                        { value: 'final', text: 'Survey End Page' },
                    ]
                },
            ]
        }
    },
    computed: {
        campaigns() {
            return this.$store.state.giftBoxCampaign.index.data;
        },
        pages() {
            return this.$store.getters[`${this.storeName}/orderedList`];
        },
    },
    created() {
        this.resetModel()
    },
    methods: {
        pageTypeChoice(choice) {
            if (choice.value === 'welcome') {
                this.model.name = 'Welcome';
                this.model.type = 'welcome';
                this.model.title = 'Welcome to our survey.';
                this.model.button_text = 'Let\'s get started!';
                this.model.page_logic_type = 'next_page';
            } else if (choice.value === 'context') {
                this.model.name = 'Statement';
                this.model.type = 'context';
                this.model.page_logic_type = 'next_page';
            } else if (choice.value === 'final') {
                this.model.type = 'final';
                this.model.title = 'Thanks for filling out our survey!';
                this.model.page_logic_type = 'hide';
                this.model.name = 'End Page';
            } else {
                this.model.name = choice.text;
                this.model.question = {
                    type: choice.value
                };
                
                switch (choice.value) {
                    case "opinion-scale":
                        this.model.question.start_from_zero = 1;
                        this.model.question.max_value = 10;
                        break;
                    case "rating":
                        this.model.question.max_value = 5;
                        break;
                    case "ranking":
                    case "single-choice":
                    case "multiple-choice":
                        this.model.question.options = ['', '', ''];
                        break;
                    case "boolean":
                        this.model.question.yes_value = 'Yes';
                        this.model.question.no_value = 'No';
                        break;
                }
            }
            this.$emit('save', this.model);
            this.resetModel();
        },
        onCancel() {
            this.$emit('close');
            this.resetModel();
        },
        resetModel() {
            this.model = { ...this.page };
        },
    },
}
</script>
